import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";


class DatiCompilatoreMIB extends React.Component {

    state = {
        datiCompilatore: {
            regione: "Veneto",
            data: this.props.statePadre && this.props.statePadre.data ? this.props.statePadre.data : "",
            ospedale: this.props.statePadre && this.props.statePadre.ospedale ? this.props.statePadre.ospedale : "",
            comune: this.props.statePadre && this.props.statePadre.comune ? this.props.statePadre.comune : "",
            segnalato: this.props.statePadre && this.props.statePadre.segnalato ? this.props.statePadre.segnalato : "",
            email: this.props.statePadre && this.props.statePadre.email ? this.props.statePadre.email : "",
            recapito: this.props.statePadre && this.props.statePadre.recapito ? this.props.statePadre.recapito : "",
            fax: this.props.statePadre && this.props.statePadre.fax ? this.props.statePadre.fax : "",
            corretto: []
        },
        listaComuni: JSON.parse(sessionStorage.getItem("comuni")),
        comuniPerCodice: JSON.parse(sessionStorage.getItem("comuniPerCodice")),

    }

    constructor(props) {
        super(props)

        this.state.datiCompilatore.regione = OggettiUtili.Regioni["050"];
        this.state.datiCompilatore.data = Utils.getTodayDateTimestamp()
        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);

    }

    componentDidMount() {
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDatiCompilatoreMIB(this.state.datiCompilatore, oggetto)

        if (Utils.isEmpty(this.props.statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiCompilatoreMIB) {
                let datiCompilatore = this.state.datiCompilatore
                let datiCompilatoreProps = this.props.segnalazioneCopia.schedaSpeciale.datiCompilatoreMIB

                datiCompilatore.data = this.props.statePadre && this.props.statePadre.data ? this.props.statePadre.data : datiCompilatoreProps.data ? datiCompilatoreProps.data : this.state.datiCompilatore.data
                datiCompilatore.ospedale = this.props.statePadre && this.props.statePadre.ospedale ? this.props.statePadre.ospedale : datiCompilatoreProps.ospedale ? datiCompilatoreProps.ospedale : this.state.datiCompilatore.ospedale
                datiCompilatore.comune = this.props.statePadre && this.props.statePadre.comune ? this.props.statePadre.comune : datiCompilatoreProps.comune ? this.state.comuniPerCodice[datiCompilatoreProps.comune] : this.state.datiCompilatore.comune
                datiCompilatore.segnalato = this.props.statePadre && this.props.statePadre.segnalato ? this.props.statePadre.segnalato : datiCompilatoreProps.segnalato ? datiCompilatoreProps.segnalato : this.state.datiCompilatore.segnalato
                datiCompilatore.email = this.props.statePadre && this.props.statePadre.email ? this.props.statePadre.email : datiCompilatoreProps.email ? datiCompilatoreProps.email : this.state.datiCompilatore.email
                datiCompilatore.recapito = this.props.statePadre && this.props.statePadre.recapito ? this.props.statePadre.recapito : datiCompilatoreProps.recapito ? datiCompilatoreProps.recapito : this.state.datiCompilatore.recapito
                datiCompilatore.fax = this.props.statePadre && this.props.statePadre.fax ? this.props.statePadre.fax : datiCompilatoreProps.fax ? datiCompilatoreProps.fax : this.state.datiCompilatore.fax

                this.setState({datiCompilatore: datiCompilatore});

            }
        }

        this.controlloDati()
        oggetto = this.createOggettoBE()
        this.props.setDatiCompilatoreMIB(this.state.datiCompilatore, oggetto)
    }

    controlloDati() {
        let datiCompilatore = this.state.datiCompilatore
        datiCompilatore.corretto = []

        if (!datiCompilatore.regione) datiCompilatore.corretto[0] = "Campo \"Regione\" mancante";

        this.setState({datiCompilatore: datiCompilatore})
    }

    createOggettoBE() {
        let datiCompilatore = JSON.parse(JSON.stringify(this.state.datiCompilatore))
        let datiCompilatoreBe = Utils.removeEmptyValueFromObject(datiCompilatore)
        if (datiCompilatore.comune && datiCompilatore.comune.codice) {
            datiCompilatore.comune = datiCompilatore.comune.codice
        }
        if (datiCompilatore.regione && datiCompilatore.regione.codice) {
            datiCompilatore.regione = datiCompilatore.regione.codice
        }
        return Utils.removeFieldFromObject(datiCompilatoreBe, "corretto")

    }

    riceviValore(field, event) {
        let datiCompilatore = this.state.datiCompilatore
        if (field.currentTarget) {
            datiCompilatore[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiCompilatore[field] = event.target.value
        }
        this.setState({datiCompilatore: datiCompilatore})

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDatiCompilatoreMIB(this.state.datiCompilatore, oggetto)
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.DatiCompilatore.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div className="container">
                    <div className="row" style={{marginTop: "1rem"}}>
                        <div className="col-lg-11">
                            <div className="row">
                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.regione")}
                                        <span className={stylesWelcome.mandatoryColor}>*</span>
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <div className={stylesWelcome.fieldContainer}>
                                        <Autocomplete
                                            id={"regione"}
                                            onChange={this.riceviValore}
                                            field={"regione"}
                                            keyField={"codice"}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            value={this.state.datiCompilatore.regione}
                                            suggestions={OggettiUtili.Regioni}
                                            placeholder={t("GestioneFocolai.informazione.regione")}
                                            disabled={true}
                                        >
                                        </Autocomplete>
                                    </div>
                                </div>

                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.dataCompilazione")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Calendar
                                        id={"data"}
                                        value={Utils.transformTimeStampForFrontend(this.state.datiCompilatore.data)}
                                        field={"data"}
                                        onChange={this.riceviValore}
                                        disabled={true}
                                        errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.MIB.DatiCompilatore.dataCompilazione"))}
                                        error={(this.state.datiCompilatore.data === "" || this.state.datiCompilatore.data == null)}
                                    >
                                    </Calendar>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "20px"}}>
                        <div className="col-lg-11">
                            <div className="row">
                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.ospedale")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"ospedale"}
                                           onChange={this.riceviValore}
                                           field={"ospedale"}
                                           value={this.state.datiCompilatore.ospedale}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.ospedale")}/>
                                </div>

                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.comune")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <div className={stylesWelcome.fieldContainer}>
                                        <Autocomplete
                                            id={"comune"}
                                            keyField={"codice"}
                                            value={this.state.datiCompilatore.comune}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            onChange={this.riceviValore}
                                            field={"comune"}
                                            placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.comune")}
                                            suggestions={this.state.listaComuni}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "20px"}}>
                        <div className="col-lg-11">
                            <div className="row">
                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.segnalato")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"segnalato"}
                                           onChange={this.riceviValore}
                                           field={"segnalato"}
                                           value={this.state.datiCompilatore.segnalato}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.segnalato")}/>
                                </div>

                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.email")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"email"}
                                           onChange={this.riceviValore}
                                           field={"email"}
                                           value={this.state.datiCompilatore.email}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.email")}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{marginTop: "1rem"}}>
                        <div className="col-lg-11">
                            <div className="row">
                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.recapito")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                    <Input id={"recapito"}
                                           onChange={this.riceviValore}
                                           field={"recapito"}
                                           value={this.state.datiCompilatore.recapito}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.recapito")}/>
                                </div>

                                <div className="col-lg-2">
                                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                                        {t("SchedaFlussoSpeciale.MIB.DatiCompilatore.fax")}
                                    </p>
                                </div>
                                <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                    <Input id={"fax"}
                                           onChange={this.riceviValore}
                                           field={"fax"}
                                           value={this.state.datiCompilatore.fax}
                                           placeholder={t("SchedaFlussoSpeciale.MIB.DatiCompilatore.fax")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                {sezione1}
            </div>

        )
    }

}

export default withTranslation('common')(DatiCompilatoreMIB)
